import axios from "axios";
import { API_ENDPOINTS } from "../utils/constants";
import { ERROR_CODE_MAP } from "utils/errorHandler";
const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8080/api";

// Create an instance of axios with the base URL
const instance = axios.create({
  baseURL: API_BASE_URL,
});

// Create a request interceptor to add the token to the request
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("pickc:token") || sessionStorage.getItem("pickc:token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Create a response interceptor to handle expired tokens
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.data?.code === 1003 || error.response?.data?.code === "1003") {
      const user = JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user") || "{}");
      const autoLogin = user?.autologin;
      const refreshToken = localStorage.getItem("pickc:refreshToken");
      const originalRequest = error.config;

      if (!autoLogin || !refreshToken) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login"; // 혹은 navigate("/login")
        return Promise.reject(ERROR_CODE_MAP[1003]);
      }

      if (!originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const res = await axios.post(
            API_ENDPOINTS.user.refresh,
            {},
            {
              baseURL: API_BASE_URL,
              headers: {
                Authorization: `Bearer ${refreshToken}`,
              },
            }
          );

          const { token, refreshToken: newRefresh } = res.data;
          localStorage.setItem("pickc:token", token);
          localStorage.setItem("pickc:refreshToken", newRefresh);

          // 다음 요청부터 사용할 Authorization 갱신
          instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          originalRequest.headers["Authorization"] = `Bearer ${token}`;

          return instance(originalRequest);
        } catch (e) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/login";
          return Promise.reject(ERROR_CODE_MAP[1003]);
        }
      }
    }

    if (ERROR_CODE_MAP[error?.response?.data?.code]) {
      return Promise.reject(ERROR_CODE_MAP[error?.response?.data?.code]);
    }
    if (ERROR_CODE_MAP[error?.response?.status]) {
      return Promise.reject(ERROR_CODE_MAP[error?.response?.status]);
    }
    return Promise.reject(error);
  }
);

export default instance;
